import { styled } from '@teko/ds-foundation';
import React, { useEffect } from 'react';
import { useTransition, animated } from 'react-spring';
import { CloseOutlined } from '@teko/ds-icon';

const BottomSheet = ({
  show,
  title,
  extra,
  closeBottomSheet,
  className,
  children,
  position,
  zIndex,
  contentHeight,
  filterNode,
  keys
}) => {
  const options = {
    top: {
      opacity: 0,
      transform: `translateY(-100%)`,
      height: "100%"
    },
    left: {
      opacity: 0,
      transform: `translateX(-100%)`,
      height: "100%"
    },
    right: {
      opacity: 0,
      transform: `translateX(100%)`,
      height: "100%"
    },
    bottom: {
      opacity: 0,
      transform: `translateY(100%)`,
      height: "100%"
    },
    show: {
      opacity: 1,
      transform: `translateY(0%)`,
      height: "100%"
    }
  };
  const entrancePosition = position || "bottom";
  const transition = useTransition(show, {
    from: options[entrancePosition],
    enter: options["show"],
    leave: options[entrancePosition],
    keys: !!keys ? keys : null
  });
  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [show]);
  return /* @__PURE__ */ React.createElement(Container, {
    zIndex,
    show
  }, transition((styles, item) => item ? /* @__PURE__ */ React.createElement(animated.div, {
    style: styles
  }, /* @__PURE__ */ React.createElement(Mask, {
    onClick: closeBottomSheet
  }), /* @__PURE__ */ React.createElement(Wrapper, null, /* @__PURE__ */ React.createElement(StyledBottomSheet, {
    className: `${className ? ` ${className}` : ""}`
  }, !!title && /* @__PURE__ */ React.createElement(BottomSheetHeader, null, closeBottomSheet && /* @__PURE__ */ React.createElement(StyledSvgIcon, {
    size: 28,
    onClick: closeBottomSheet
  }), /* @__PURE__ */ React.createElement(BottomSheetTitle, null, title), /* @__PURE__ */ React.createElement(BottomSheetExtra, null, extra), /* @__PURE__ */ React.createElement(BottomSheetFilter, null, filterNode)), /* @__PURE__ */ React.createElement(BottomSheetContent, {
    contentHeight,
    className: "bottom-sheet-content"
  }, children)))) : null));
};
const StyledSvgIcon = styled(CloseOutlined)`
  position: absolute;
  top: 12px;
  left: 12px;
`;
const StyledBottomSheet = styled.div`
  background: #ffffff;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  bottom: 0;
  position: fixed;
`;
const BottomSheetHeader = styled.div`
  position: relative;
  text-align: center;
  padding: 16px 0;
  border-bottom: 1px solid #e0e0e0;
`;
const BottomSheetTitle = styled.span`
  font-size: 16px;
  font-weight: 500;
`;
const BottomSheetExtra = styled.span`
  position: absolute;
  right: 15px;
`;
const BottomSheetContent = styled.div`
  ${({ contentHeight }) => contentHeight ? `height: ${contentHeight}` : "max-height: 75vh"};
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
`;
const Container = styled.div(({ show, zIndex }) => `
    top: 0;
    bottom: 0;
    left: 0;
    position: fixed;
    pointer-events: none;
    transition: transform 0.3s ease-out;
    ${show ? ` z-index: ${zIndex ? zIndex : 1050};
    background-color: rgba(0, 0, 0, 0.3);
    will-change: transform;
    pointer-events: all;` : ""}

  `);
const BottomSheetFilter = styled.div`
  width: 100%;
`;
const Mask = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`;
const Wrapper = styled.div`
  width: 100vw;
  height: 0vh;
  bottom: 0px;
  position: inherit;
  overflow: auto;
`;

export { BottomSheet };
